import { apiClient } from './apiClient';
import { Allergens } from './ingredients';

export interface FoodGroupFoodDto {
  id: string;
  name: string;
}

export interface FoodGroupDto {
  id: string;
  key: string;
  name: string;
  description: string;
  foodCount: number;
  sortOrder: number;
  foods: FoodGroupFoodDto[];
  isCustom: boolean;
}

export interface PreviewFoodGroupRequest {
  categoryIds?: string[];
  minDurationMinutes?: number;
  maxDurationMinutes?: number;
  excludedAllergens?: Allergens;
}

export interface FoodGroupPreviewFoodDto {
  id: string;
  name: string;
  durationMinutes: number;
  categoryNames: string[];
}

export interface PreviewFoodGroupResponse {
  foods: FoodGroupPreviewFoodDto[];
}

export interface CreateFoodGroupRequest {
  name: string;
  description: string;
  foodIds: string[];
  categoryIds?: string[];
  minDurationMinutes?: number;
  maxDurationMinutes?: number;
  excludedAllergens?: Allergens;
}

export async function getAllFoodGroups(): Promise<FoodGroupDto[]> {
  return apiClient.get<FoodGroupDto[]>('/api/FoodGroups');
}

export async function previewFoodGroup(request: PreviewFoodGroupRequest): Promise<PreviewFoodGroupResponse> {
  return apiClient.post<PreviewFoodGroupRequest, PreviewFoodGroupResponse>('/api/FoodGroups/preview', request);
}

export async function createFoodGroup(request: CreateFoodGroupRequest): Promise<FoodGroupDto> {
  return apiClient.post<CreateFoodGroupRequest, FoodGroupDto>('/api/FoodGroups', request);
}

export async function deleteFoodGroup(id: string): Promise<void> {
  return apiClient.delete<void>(`/api/FoodGroups/${id}`);
}
